const createDeleteService = ({
  apiDeleteCart,
  formDataFactory = () => new FormData(),
}) => {
  const processDeleting = (articleIds, quantities) => {
    const formData = formDataFactory()

    articleIds.forEach((id, index) => {
      formData.append('article[]', id)
      formData.append('amount[]', quantities[index])
    })

    apiDeleteCart(formData)
  }

  return { processDeleting }
}

export { createDeleteService }
export default createDeleteService
